<template>
    <div id="sibebar_container" class="modal fade" role="dialog" style="padding-right: 0 !important;">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content" v-if="auth_type === 'login'">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h2>{{trans('auth.LOGIN_ACCOUNT','Login to your account')}}</h2>

                    <p>{{trans('auth.DontHaveAnAccount',"Don't have an account?")}} <a href="Javascript:void(0);" @click="setAuthModalType('signup')">{{trans('auth.SIGNUP','SIGN UP')}}</a></p>
                </div>
                <div class="modal-body">
                    <div class="sibebar_container">
                        <login-form/>
                    </div>
                </div>
            </div>
            <div class="modal-content" v-if="auth_type === 'signup'">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h2>{{trans('auth.CREATE_ACCOUNT','CREATE ACCOUNT')}}</h2>

                    <p>{{trans('auth.have_account','Already have an account?')}} <a href="Javascript:void(0);" @click="setAuthModalType('login')">{{trans('auth.Login','Login')}}</a></p>
                </div>
                <div class="modal-body">
                    <div class="sibebar_container">
                        <signup-form/>
                    </div>
                </div>
            </div>
            <div class="modal-content" v-if="auth_type === 'reset_password'">
                <forget-password-from/>
            </div>


        </div>
    </div>
</template>
<script>
import {mapState, mapActions} from "vuex";
import LoginForm from "../LoginForm";
import SignupForm from "../SignupForm";
import ForgetPasswordFrom from "../ForgetPasswordForm";
export default {
    name: 'AuthModal',
    components: {ForgetPasswordFrom, LoginForm,SignupForm},
    computed:{
        ...mapState(['isLoading','auth_type']),
    },
    methods: {
        ...mapActions(['setAuthModalType']),
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
    }
}
</script>
